<div class="reports-old-page">
  @if(!loadingReport) {
    @if(!periodoSeleccionado) {
    <div class="reports-old-alert reports-old-alert--info">
      <p-message severity="info" icon="pi pi-info-circle"
        [text]="'REPORTS.HISTORY_SELECT_MONTH_INFO' | translate" />
    </div>
    } @else if (!reportLoaded) {
    <div class="reports-old-alert reports-old-alert--warn">
      <p-message severity="warn" icon="pi pi-exclamation-triangle"
        [text]="'REPORTS.HISTORY_NO_REPORT' | translate" />
    </div>
    }
  }

  @if (canViewLogs && reportLoaded && informeClosedByName) {
  <div class="reports-old-alert reports-old-alert--info">
    <p-message severity="info" icon="pi pi-history"
      [text]="'REPORTS.HISTORY_CLOSED_BY' | translate:{ name: informeClosedByName, date: informeClosedAtLabel }" />
  </div>
  }

  <header class="reports-old-hero">
    <div class="reports-old-hero__inner">
      <div class="reports-old-hero__brand">
        <button type="button" class="reports-old-hero__back" (click)="atras()"
          [attr.aria-label]="'REPORTS.BTN_BACK' | translate">
          <i class="pi pi-arrow-left" aria-hidden="true"></i>
        </button>
        <div class="reports-old-hero__text">
          <span class="reports-old-hero__eyebrow">{{ 'REPORTS.HISTORY_HERO_EYEBROW' | translate }}</span>
          <h1 class="reports-old-hero__title">{{ 'REPORTS.HISTORY_HERO_TITLE' | translate }}</h1>
        </div>
      </div>
      <div class="reports-old-hero__meta">
        @if (periodoDisplayUi) {
        <span class="reports-old-hero__chip">
          <i class="pi pi-calendar" aria-hidden="true"></i>
          <span class="notranslate">{{ periodoDisplayUi }}</span>
        </span>
        }
        <p-button type="button" icon="pi pi-file-pdf" [loading]="loadingPdf" (click)="exportarPDF()"
          [label]="'REPORTS.HISTORY_EXPORT_PDF' | translate" styleClass="reports-old-hero__btn reports-old-hero__btn--cta"
          [disabled]="!reportLoaded" />
      </div>
    </div>
  </header>

  <article class="reports-old-toolbar">
    <div class="reports-old-toolbar__icon" aria-hidden="true">
      <i class="pi pi-search"></i>
    </div>
    <div class="reports-old-toolbar__field">
      <p-floatLabel variant="on">
        <p-datepicker inputId="periodPicker" [(ngModel)]="selectedMonth" view="month" [showIcon]="true"
          dateFormat="mm/yy" (ngModelChange)="onMonthChange($event)" appendTo="body" styleClass="w-100"
          [placeholder]="'REPORTS.HISTORY_PICKER_PLACEHOLDER' | translate" />
        <label for="periodPicker">{{ 'REPORTS.HISTORY_MONTH_FIELD' | translate }}</label>
      </p-floatLabel>
    </div>
  </article>

  <article class="reports-old-document" id="reporteCard">
    <header class="reports-old-document__head">
      <div class="reports-old-document__logo">
        <img class="reports-old-document__logo-img" src="../../../assets/images/logo_mmm.png" alt="Logo MMM" />
      </div>
      <div class="reports-old-document__titles">
        <p class="reports-old-document__line">{{ 'REPORTS.HEADER_LINE_1' | translate }}</p>
        <p class="reports-old-document__line reports-old-document__line--bold">{{ 'REPORTS.HEADER_LINE_2' | translate }}</p>
        <p class="reports-old-document__subtitle">{{ 'REPORTS.HEADER_SUBTITLE' | translate }}</p>
      </div>
    </header>

    <div class="reports-old-document__meta">
      <div class="reports-old-document__field">
        <label class="reports-old-document__label">{{ 'REPORTS.FIELD_CHURCH' | translate }}</label>
        <input pInputText [(ngModel)]="iglesiaName" class="reports-old-document__input" readonly />
      </div>
      <div class="reports-old-document__field">
        <label class="reports-old-document__label">{{ 'REPORTS.FIELD_MONTH_YEAR' | translate }}</label>
        <input pInputText [value]="periodoDisplayUi" class="reports-old-document__input" readonly />
      </div>
    </div>

    <div class="reports-old-document__grid">
      <div class="reports-old-document__col">
        <section class="reports-old-section">
          <h3 class="reports-old-section__title">{{ 'REPORTS.SECTION_SPIRITUAL' | translate }}</h3>
          <p-table [value]="informeEspiritualOptions" [paginator]="false" showGridlines
            styleClass="reports-old-table" [tableStyle]="{ 'min-width': '100%' }">
            <ng-template #header>
              <tr>
                <th class="text-center">#</th>
                <th>{{ 'REPORTS.COL_DESC' | translate }}</th>
                <th class="text-center">{{ 'REPORTS.COL_RESP' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template #body let-product>
              <tr>
                <td class="text-center">{{ product.item }}</td>
                <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
                <td class="text-center">{{ product.valor }}</td>
              </tr>
            </ng-template>
          </p-table>
        </section>

        <section class="reports-old-section">
          <h3 class="reports-old-section__title">{{ 'REPORTS.SECTION_FINANCIAL' | translate }}</h3>
          <p-table [value]="informeFinancieroIngresosOptions" [paginator]="false" showGridlines
            styleClass="reports-old-table" [tableStyle]="{ 'min-width': '100%' }">
            <ng-template pTemplate="header">
              <tr>
                <th class="text-center"></th>
                <th>{{ 'REPORTS.SUBSECTION_INCOME' | translate }}</th>
                <th class="text-center">{{ 'REPORTS.COL_AMOUNT' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
              <tr [class.reports-old-table__row--total]="product.item === ''">
                @if(product.item === ''){
                <td class="text-center">{{ product.item }}</td>
                <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
                <td class="text-end">{{ product.valor | missionMoney }}</td>
                } @else {
                <td class="text-center">{{ product.item }}</td>
                <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
                <td class="text-end" [class.fw-bold]="(product?.valor || 0) > 0">{{ product.valor | missionMoney }}</td>
                }
              </tr>
            </ng-template>
          </p-table>

          <p-table [value]="informeFinancieroEgresosB1Options" [paginator]="false" showGridlines
            styleClass="reports-old-table reports-old-table--spaced" [tableStyle]="{ 'min-width': '100%' }">
            <ng-template #header>
              <tr>
                <th class="text-center"></th>
                <th>{{ 'REPORTS.SUBSECTION_EXPENSE_B1' | translate }}</th>
                <th class="text-center">{{ 'REPORTS.COL_AMOUNT' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template #body let-product>
              <tr [class.reports-old-table__row--total]="product.item === ''">
                @if(product.item === ''){
                <td class="text-center">{{ product.item }}</td>
                <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
                <td class="text-end">{{ product.valor | missionMoney }}</td>
                } @else {
                <td class="text-center">{{ product.item }}</td>
                <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
                <td class="text-end" [class.fw-bold]="(product?.valor || 0) > 0">{{ product.valor | missionMoney }}</td>
                }
              </tr>
            </ng-template>
          </p-table>
        </section>
      </div>

      <div class="reports-old-document__col">
        <section class="reports-old-section">
          <h3 class="reports-old-section__title">{{ 'REPORTS.SECTION_WORKER' | translate }}</h3>
          <p-table [value]="informeObreoOptions" [paginator]="false" showGridlines
            styleClass="reports-old-table" [tableStyle]="{ 'min-width': '100%' }">
            <ng-template #header>
              <tr>
                <th class="text-center">#</th>
                <th>{{ 'REPORTS.COL_DESC' | translate }}</th>
                <th class="text-center">{{ 'REPORTS.COL_RESP' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template #body let-product>
              <tr>
                <td class="text-center vcenter">{{ product.item }}</td>
                <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
                <td class="text-center vcenter">
                  @if(!isExporting) {
                  <div class="cell">
                    <p-tag class="badge-export"
                      [severity]="isObreroAffirmative(product.valor) ? 'info' : 'secondary'">
                      {{ obreroTagLabel(isObreroAffirmative(product.valor)) }}
                    </p-tag>
                  </div>
                  } @else {
                  <span>{{ obreroTagLabel(isObreroAffirmative(product.valor)) }}</span>
                  }
                </td>
              </tr>
            </ng-template>
          </p-table>
        </section>

        <p-table [value]="informeFinancieroEgresosB2Options" [paginator]="false" showGridlines
          styleClass="reports-old-table reports-old-table--spaced" [tableStyle]="{ 'min-width': '100%' }">
          <ng-template #header>
            <tr>
              <th class="text-center"></th>
              <th>{{ 'REPORTS.SUBSECTION_EXPENSE_B2' | translate }}</th>
              <th class="text-center">{{ 'REPORTS.COL_AMOUNT' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template #body let-product>
            <tr [class.reports-old-table__row--total]="product.item === ''">
              @if(product.item === ''){
              <td class="text-center">{{ product.item }}</td>
              <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
              <td class="text-end">{{ product.valor | missionMoney }}</td>
              } @else {
              <td class="text-center">{{ product.item }}</td>
              <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
              <td class="text-end" [class.fw-bold]="(product?.valor || 0) > 0">{{ product.valor | missionMoney }}</td>
              }
            </tr>
          </ng-template>
        </p-table>

        <p-table [value]="informeFinancieroBalanceOptions" [paginator]="false" showGridlines
          styleClass="reports-old-table reports-old-table--spaced" [tableStyle]="{ 'min-width': '100%' }">
          <ng-template #header>
            <tr>
              <th>{{ 'REPORTS.SUBSECTION_BALANCE' | translate }}</th>
              <th class="text-center">{{ 'REPORTS.COL_AMOUNT' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template #body let-product>
            <tr [class.reports-old-table__row--total]="product.codigo === 'BAL-FINAL'">
              @if(product.codigo === 'BAL-FINAL'){
              <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
              <td class="text-end">{{ product.valor | missionMoney }}</td>
              } @else {
              <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
              <td class="text-end" [class.fw-bold]="(product?.valor || 0) > 0">{{ product.valor | missionMoney }}</td>
              }
            </tr>
          </ng-template>
        </p-table>

        <section class="reports-old-section reports-old-section--obs">
          <h3 class="reports-old-section__title">{{ 'REPORTS.OBSERVATIONS' | translate }}</h3>
          @if(!isExporting) {
          <textarea rows="6" pTextarea [autoResize]="false" [(ngModel)]="observaciones"
            class="reports-old-document__textarea w-100" readonly></textarea>
          } @else {
          <div class="export-text-wrap" [innerText]="observaciones"></div>
          }
        </section>
      </div>
    </div>

    <footer class="reports-old-document__footer">
      <div class="reports-old-document__field">
        <label class="reports-old-document__label">{{ 'REPORTS.FIELD_PASTOR' | translate }}</label>
        <input pInputText [(ngModel)]="pastorName" class="reports-old-document__input" readonly />
      </div>
      <div class="reports-old-document__signature">
        <label class="reports-old-document__label">{{ 'REPORTS.FIELD_SIGNATURE' | translate }}</label>
        <div class="reports-old-document__signature-box">
          @if (hasSignatureImage) {
          <img id="firmaImg" [src]="imageFirmaUrl!" [attr.alt]="('REPORTS.SIGNATURE_ALT' | translate)"
            (error)="handleSignatureImageError()" />
          } @else {
          <div class="reports-old-document__signature-empty">
            <i class="pi pi-pen-to-square" aria-hidden="true"></i>
            <span>{{ 'REPORTS.SIGNATURE_EMPTY' | translate }}</span>
          </div>
          }
        </div>
      </div>
    </footer>

    <p class="reports-old-document__quote">{{ 'REPORTS.FOOTER_QUOTE' | translate }}</p>
  </article>
</div>

<p-toast></p-toast>
